/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSerialVerifyBody
 */
export interface EarnSerialVerifyBody {
    /**
     * 
     * @type {string}
     * @memberof EarnSerialVerifyBody
     */
    objectiveTemplateId: string;
    /**
     * 
     * @type {string}
     * @memberof EarnSerialVerifyBody
     */
    serialNumber: string;
}

/**
 * Check if a given object implements the EarnSerialVerifyBody interface.
 */
export function instanceOfEarnSerialVerifyBody(value: object): value is EarnSerialVerifyBody {
    if (!('objectiveTemplateId' in value) || value['objectiveTemplateId'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    return true;
}

export function EarnSerialVerifyBodyFromJSON(json: any): EarnSerialVerifyBody {
    return EarnSerialVerifyBodyFromJSONTyped(json, false);
}

export function EarnSerialVerifyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSerialVerifyBody {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'],
        'serialNumber': json['serialNumber'],
    };
}

export function EarnSerialVerifyBodyToJSON(json: any): EarnSerialVerifyBody {
    return EarnSerialVerifyBodyToJSONTyped(json, false);
}

export function EarnSerialVerifyBodyToJSONTyped(value?: EarnSerialVerifyBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
        'serialNumber': value['serialNumber'],
    };
}

